import { Price } from '@/types';

/* For objects with price arrays (currently RawMaterial and Mix), returns the Price-object with the latest valid_from */
export default function useGetPrice(mixOrRawMaterial: { [key: string]: any; prices: Price[] }) {
    return mixOrRawMaterial.prices.reduce(
        (latestPrice, currentPrice) => (latestPrice === null || Date.parse(currentPrice.valid_from) - Date.parse(latestPrice.valid_from) >= 0 ? currentPrice : latestPrice),
        null as null | Price
    );
}
